package com.shmbles.web.components

import androidx.compose.runtime.Composable
import com.shmbles.web.models.Section
import com.shmbles.web.models.Theme
import com.shmbles.web.styles.LogoStyle
import com.shmbles.web.styles.NavigationItemStyle
import com.shmbles.web.util.Constants.FONT_FAMILY
import com.shmbles.web.util.Res
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.icons.fa.FaBars
import com.varabyte.kobweb.silk.components.icons.fa.IconSize
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.breakpoint.displayIfAtLeast
import com.varabyte.kobweb.silk.style.breakpoint.displayUntil
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px

@Composable
fun Header(onMenuClicked: () -> Unit) {
    val breakpoint = rememberBreakpoint()
    Row(
        modifier = Modifier
            .fillMaxWidth(if (breakpoint > Breakpoint.MD) 80.percent else 90.percent)
            .margin(topBottom = if (breakpoint > Breakpoint.MD) 40.px else 20.px),
        horizontalArrangement = Arrangement.SpaceBetween,
        verticalAlignment = Alignment.CenterVertically
    ) {
        LeftSide(
            onMenuClicked = onMenuClicked
        )
        RightSide()
    }
}

@Composable
fun LeftSide(onMenuClicked: () -> Unit) {
    Row(verticalAlignment = Alignment.CenterVertically) {
        FaBars(
            modifier = Modifier
                .displayUntil(Breakpoint.MD)
                .margin(right = 15.px)
                .cursor(Cursor.Pointer)
                .onClick { onMenuClicked() },
            size = IconSize.XL
        )
        Image(
            modifier = LogoStyle.toModifier().width(140.px),
            src = Res.Image.logo,
            description = "Logo"
        )
    }
}

@Composable
fun RightSide() {
    Row(
        modifier = Modifier
            .displayIfAtLeast(Breakpoint.MD)
            .borderRadius(r = 50.px)
            .backgroundColor(Theme.LighterGray.rgb)
            .padding(all = 20.px),
        horizontalArrangement = Arrangement.End
    ) {
        listOf(Section.Home, Section.About, Section.Service, Section.Companies).forEach { section ->
            Link(
                modifier = NavigationItemStyle.toModifier()
                    .padding(right = 30.px)
                    .fontFamily(FONT_FAMILY)
                    .fontSize(18.px)
                    .fontWeight(FontWeight.Normal)
                    .textDecorationLine(TextDecorationLine.None),
                path = section.path,
                text = section.title
            )
        }
    }
}